<template>
    <div>
        <div v-if="isShow">
            <error-alert 
                :variant="orderResponse.variant"
                :msg="orderResponse.message"
                :errorMsg="orderResponse.errmsg"
            />
        </div>

        <b-row class="checkout-cart mb-4">
            <div v-if="proceedLoading"><div class="loading"></div></div>
            <div class="col-md-12 your-cart pr-lg-0 mb-3">
                
                <div class="cart-details">
                    <h2>{{ $t('Personal Information') }}</h2>
                    <!-- <b-form  @submit.prevent="handleSubmit"> -->
                        <b-card class="checkout-cart mb-4">
                            <b-row>
                                <!-- <div class="col-lg-2 col-md-3 col-xs-12">
                                <div class="form-group">
                                    <label for="salutation">
                                        {{ $t('Salutation') }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <b-form-select 
                                        v-model="form.salutation" 
                                        :options="options" 
                                        id="salutation" 
                                        name="salutation"
                                        type="select"
                                        class="input-field" >
                                    </b-form-select>
                                    </div>
                                </div> -->
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                    <div class="form-group">
                                        <div class="material-input position-relative mb-4">
                                          <input type="text" class="form-control" placeholder=""
                                                 id="first_name"
                                                 v-model.trim="form.firstName"
                                                 maxlength="50"
                                                 name="first_name"
                                                 @blur="validateFormData"
                                                 >
                                          <label for="first_name">{{ $t('Firstname') }} <span class="text-danger">*</span></label>
                                        </div>
                                    </div>
                                </div>
                                <b-col class="col-lg-6 col-md-6 col-xs-12">
                                    <div class="form-group">
                                      <div class="material-input position-relative mb-4">
                                        <input type="text" class="form-control" placeholder=""
                                               id="last_name"
                                               name="last_name"
                                                v-model.trim="form.lastName"
                                                maxlength="50"
                                                @blur="validateFormData"
                                        />
                                        <label for="last_name">{{ $t('Lastname') }} <span class="text-danger">*</span></label>
                                      </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-input position-relative mb-4">
                                      <input type="text" class="form-control" :placeholder="$t('Enter number as +385 (40) 123123')"
                                          id="phone_number"
                                          @keypress="isPhoneNo()"
                                          v-model="form.contactNumber"
                                          maxlength="21"
                                          @blur="validateFormData"
                                      />
                                      <label for="phone_number"> {{ $t('Contact Number') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-input position-relative mb-4">
                                      <input type="text" class="form-control" placeholder=""
                                          id="email"
                                          name="email"
                                          v-model.trim="form.email"
                                          maxlength="50" 
                                          @blur="validateFormData"
                                          />
                                      <label for="email">{{ $t('Email') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>
                            </b-row>
                            <b-row>
                                <div class="form-group">
                                    <b-col cols="12">
                                    </b-col>
                                </div>
                            </b-row>
                            <b-row>
                                <div class="form-group">
                                    <b-col cols="12">
                                        <h5>{{ $t("Billing Address") }}</h5>
                                    </b-col>
                                </div>
                            </b-row>
                            <b-row>
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-input position-relative mb-4">
                                      <b-form-input type="text" placeholder=""
                                          name="billingAddress.address1"
                                          id="billingAddress.address1"
                                          v-model.trim="form.billingAddress.address1"
                                          maxlength="50"
                                          @blur="validateFormData"
                                          >
                                      </b-form-input>
                                      <label for="billingAddress.address1">{{ $t('Street Name, Building Number') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-select mb-4">
                                      <select id="billingCountry"
                                                     name="billingAddress['country']"
                                                     v-model.trim="form.billingAddress.country"
                                                     @change="validateFormData"
                                      >
                                        <option :value="null">{{ $t('Please select country') }}</option>
                                        <option v-for="(country) in countriesList" :key="country.id" :value="country.id"  >{{ country.name  }}</option>
                                      </select>
                                      <label for="billingCountry">{{ $t('Country') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>
                                <!-- <b-col cols="6">
                                    <div class="form-group">
                                        <label for="name">{{ $t('Address 2') }}</label>
                                        <b-form-input
                                            id="billingAddress['address2']" 
                                            name="billingAddress['address2']"
                                            type="text"
                                            v-model.trim="form.billingAddress.address2"
                                            maxlength="50"
                                            required="required"
                                            >
                                        </b-form-input>
                                    </div>
                                </b-col> -->
                            </b-row>
                            <b-row>
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-input position-relative mb-4">
                                      <b-form-input type="text" placeholder=""
                                          id="billingAddress['city']"
                                          name="billingAddress['city']"
                                          v-model.trim="form.billingAddress.city"
                                          maxlength="50"
                                          @blur="validateFormData"
                                      >
                                      </b-form-input>
                                      <label for="name">{{ $t('City') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-input position-relative mb-4">
                                      <b-form-input type="text" placeholder=""
                                          id="billingAddress['zipcode']"
                                          name="billingAddress['zipcode']"
                                          v-model.trim="form.billingAddress.zipcode"
                                          maxlength="5"
                                          @blur="validateFormData"
                                      >
                                      </b-form-input>
                                      <label for="name">{{ $t('Zipcode') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>

                            </b-row>
                            <b-row>
                                <div class="form-group">
                                    <b-col cols="12">
                                    </b-col>
                                </div>
                            </b-row>
                            <b-row v-if="showShipping">
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <h5>{{ $t("Shipping Address") }}</h5>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-xs-12" v-if="showShipping">
                                  <best-dropdown :options="shippingMethodTypes" :defaultValue="shippingAddressType" @change="HandleSelectedShipping"/>
                                </div>
                            </b-row>
                            <!-- <b-row v-if="showShipping">
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                    <div class="form-group">
                                        <b-form-checkbox
                                            id="checkbox-1"
                                            v-model="status"
                                            @change="sameAddress($event)"
                                            name="checkbox-1"
                                            value="1"
                                            unchecked-value="0"
                                            > {{ $t('Same as billing address') }}
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </b-row> -->

                            <b-form-radio-group v-if="showShipping && false" v-model="shippingAddressType" name="shipping-address-type">
                                <b-row>
                                    <b-col><b-form-radio value="billing">{{ $t('Same as billing address') }}</b-form-radio></b-col>
                                    <b-col><b-form-radio value="different">{{ $t('Ship to different location') }}</b-form-radio></b-col>
                                    <b-col><b-form-radio value="servicepoint">{{ $t('Ship to service point') }}</b-form-radio></b-col>
                                </b-row>

                            </b-form-radio-group>

                            <b-row v-if="shippingAddressType == 'servicepoint' && showShipping">
                                <b-col>
                                    <div class="my-4">
                                        <label>{{ $t("FIND SERVICE POINT") }}</label>
                                            <div class="my-appointment">
                                            <div class="row">
                                                <div class="col-9 col-sm-10 col-md-10 mb-3 pr-0">
                                                    <vue-google-autocomplete
                                                        id="map"
                                                        classname="location-input text-secondary"
                                                        :class="addressError"
                                                        :placeholder="$t('Enter zip code/ location to search nearby service points')"
                                                        v-on:placechanged="getAddressData"
                                                        :country="['fi']"
                                                        v-model="address"
                                                        required="true"
                                                        types="geocode"
                                                        ref="autocomplete"
                                                    >
                                                    </vue-google-autocomplete>
                                                </div>
                                                <div class="col-3 col-sm-2 col-md-2 mb-3">
                                                    <button class="btn btn-location" @click="getDealerServices()"><i class="fas fa-search"></i> {{ $t("Find") }}</button>
                                                </div>
                                            </div>

                                            <div class="loading" v-if="servicepointloading"></div>
                                            <div v-if="showServices && dealerServiceList.length && !servicepointloading">
                                                <label class="text-capitalize">{{ $t("Suggested Service points") }}</label>

                                                <multiselect 
                                                    v-model="servicePointAddress"
                                                    :options="dealerServiceList" 
                                                    track-by="id"
                                                    label="company_name" 
                                                    :option-height="104"
                                                    :custom-label="customLabel"
                                                    :placeholder="$t('Select service point')"
                                                    class="border border-dark">

                                                    <template slot="singleLabel" slot-scope="props">
                                                        <span class="option__company_name">
                                                            {{ props.option.company_name }} - {{ props.option.city }}
                                                        </span>
                                                    </template>
                                                    
                                                    <template slot="option" slot-scope="props">
                                                        <div class="option__desc">
                                                            <div>{{ props.option.company_name }} - {{ parseFloat(props.option.distance_km).toFixed(2) }} {{ $t('km') }}</div>
                                                            <div>{{ props.option.address_line_1 }} {{ props.option.address_line_2 }}</div>
                                                            <div>{{ props.option.zipcode }}, {{ props.option.city }}</div>
                                                        </div>
                                                    </template>
                                                </multiselect>

                                                <!-- <div v-for="(dealerservice, index) in dealerServiceList" :key="index" class="garage-list border">
                                                    <div  class="d-flex align-items-center justify-content-between p-3 border-bottom flex-wrap flex-sm-wrap">
                                                        <div class="mb-3 mb-md-0 w-40">
                                                            <h4>{{ dealerservice.company_name }}</h4>
                                                            <p>{{ dealerservice.address_line_1 }} {{ dealerservice.address_line_2 || ''}}</p>
                                                            <p>{{ dealerservice.zipcode }}</p>
                                                            <p v-if="dealerservice.city">{{ dealerservice.city }}</p>
                                                            <p>{{ $t("Distance to location:") +' '+ distanceToLocation(dealerservice.distance_km) + ' km' }}</p>
                                                        </div>
                                                        <button class="text-uppercase bg-dark-gray pt-2 pb-2 pl-3 rounded pr-3 color-white appointment-btn">{{ $t("Select service point") }}</button>
                                                    </div>
                                                </div> -->
                                            </div>
                                            <div v-else-if="showServices && dealerServiceList.length > 0">
                                                <label class="text-uppercase">{{ $t("Suggested Service points") }}</label>
                                                {{ $t("It seems there is no service point available for the selected location. Kindly contact us on Chat or customer service 0405529803 for further assistance.") }}
                                            </div> 
                                        </div> 
                                    </div>
                                </b-col>
                            </b-row>

                            <b-row v-if="showShipping && shippingAddressType != 'servicepoint'" v-show="shippingAddressType !== 'billing'" class="mt-4">
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                    <div class="form-group">
                                      <div class="material-input position-relative mb-4">
                                        <b-form-input type="text" placeholder=""
                                            id="shippingAddressAddress1"
                                            name="shippingAddress['address1']"
                                            v-model.trim="form.shippingAddress.address1"
                                            :readonly="status"
                                            maxlength="50"
                                            >
                                        </b-form-input>
                                        <label for="shippingAddressAddress1">{{ $t('Street Name, Building Number') }} <span class="text-danger">*</span></label>
                                      </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-select">
                                      <select v-model.trim="form.shippingAddress.country"
                                              id="shippingAddressCountry"
                                              name="shippingAddress['country']"
                                              :disabled="status">
                                        <option :value="null">{{ $t('Please select country') }}</option>
                                        <option v-for="(country) in countriesList" :key="country.id" :value="country.id">{{ country.name }}</option>
                                      </select>
                                      <label for="shippingAddressCountry">{{ $t('Country') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>
                                <!-- <div class="col-lg-6 col-md-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="name">{{ $t('Address 2') }}</label>
                                        <b-form-input
                                            id="shippingAddress['address2']" 
                                            name="shippingAddress['address2']"
                                            type="text"
                                            v-model.trim="form.shippingAddress.address2"
                                            :readonly="status == 1"
                                            maxlength="50"
                                            required="required"
                                            >
                                        </b-form-input>
                                    </div>
                                </div> -->
                            </b-row>
                            <b-row v-if="showShipping && shippingAddressType != 'servicepoint'" v-show="shippingAddressType !== 'billing'">
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-input position-relative mb-4">
                                      <b-form-input type="text" placeholder=""
                                          id="shippingAddressCity"
                                          name="shippingAddress['city']"
                                          v-model.trim="form.shippingAddress.city"
                                          :readonly="status"
                                          maxlength="50"
                                      >
                                      </b-form-input>
                                      <label for="shippingAddressCity">{{ $t('City') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-xs-12">
                                  <div class="form-group">
                                    <div class="material-input position-relative mb-4">
                                      <b-form-input type="text" placeholder=""
                                          id="shippingAddressZipcode"
                                          name="shippingAddress['zipcode']"
                                          v-model.trim="form.shippingAddress.zipcode"
                                          :readonly="status"
                                          maxlength="5"
                                      >
                                      </b-form-input>
                                      <label for="shippingAddressZipcode">{{ $t('Zipcode') }} <span class="text-danger">*</span></label>
                                    </div>
                                  </div>
                                </div>

                            </b-row>
                            <b-row>

                                <b-col lg="6" md="6" sm="12">
                                  <div class="form-group">
                                    <div class="material-input position-relative">
                                      <b-form-input type="text" placeholder=""
                                                    id="order_note"
                                                    name="order_note"
                                                    v-model.trim="form.order_note"
                                                    maxlength="50"
                                      >
                                      </b-form-input>
                                      <label for="order_note"> {{ $t('Order Notes') }} </label>
                                      <span :style="{ fontSize: '12px' }">{{$t("You can't use more than 50 characters")}} </span>
                                    </div>
                                  </div>
                                </b-col>
                                <b-col lg="6" md="6" sm="12">
                                    <div class="form-group">
                                      <div class="material-input position-relative">
                                        <b-form-input type="text" placeholder=""
                                            id="licencePlate"
                                            name="licencePlate"
                                            v-model.trim="form.licencePlate"
                                            maxlength="50"
                                            >
                                        </b-form-input>
                                        <label for="licencePlate"> {{ $t('Licence Plate') }} </label>
                                      </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                  <label class="checkbox-container">
                                    <input type="checkbox" v-model="form.conditions" @change="validateFormData"/>
                                    <span class="checkmark"></span>
                                    <span class="checkbox-label">{{ $t("I agree with the") }} <router-link :to="{ name: 'cmspage', params: {pagepath: 'terms-and-condition' }}" target='_blank' >{{ $t('Terms and Condition') }}</router-link> {{ $t('and') }} <router-link :to="{ name: 'cmspage', params: {pagepath: 'privacy-policy' }}"  target= '_blank'>{{ $t('Privacy Policy') }}</router-link>.</span>
                                  </label>
                                </b-col>
                            </b-row>
                            <b-row>
                                <div class="col-sm-12 col-md-6 pl-0 my-3 order-2 order-md-1">
                                  <a href="javascript:void(0);" @click="goToServicePointOrCart()" class="btn btn-link left-link text-muted font-14">
                                    <i class="fa fa-arrow-left"></i>
                                    <span class="pl-2" v-if="!showShipping">{{ $t("Back to service point selection") }}</span>
                                    <span class="pl-2" v-if="showShipping">{{ $t("Back to cart") }}</span>
                                  </a>
                                </div>
                                <div class="col-sm-12 col-md-6 align-items-start order-1 order-md-2">
                                    <b-button :disabled="!isFormValid" class="color-white rounded btn-block py-3 bg-green" value="Submit" @click="handleSubmit">
                                        <span class="text-uppercase pb-1">{{ $t("Choose way of payment") }}</span>
                                    </b-button>
                                    <p class="font-14 mb-0 mt-2 text-center" style="white-space: normal; word-break: break-word" :class="{'text-danger' : (!form.conditions), 'd-none' : (form.conditions)}">{{ $t("Please accept terms and policies")  }}</p>
                                </div>
                            </b-row>
                        </b-card>
                        
                        <!-- </b-form> -->
                    </div>
                </div>
            </b-row>
    </div>
</template>
<style scoped>
.vue-country-select {
    border: 1px solid #bbb !important;
    border-bottom-right-radius: 0px !important;
    border-top-right-radius: 0px !important;
}
.custom-select {
    background-color: #fff !important;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/*--Materiel Input Box Css Started--*/
.material-input {position: relative;margin-bottom: 20px;}
.material-input .form-control {padding: 20px 12px 5px 12px;border: 1px solid #ced4da;border-radius: 4px;transition: border-color 0.3s ease, box-shadow 0.3s ease;}
.material-input .form-control:focus {border: 1px solid #212529;box-shadow: 0 0 0 0.2rem #0000003b;}
.material-input .form-control[disabled] {background-color: #e9ecef;border: 1px solid #ced4da;cursor: not-allowed;color: #6c757d;}
.material-input .form-control[disabled]:hover {box-shadow: none;}
.material-input label {position: absolute;top: 14px;left: 12px;pointer-events: none;font-size: 16px;transition: all 0.2s ease;background: white;padding: 2px 4px;color: #6c757d;width: 80%;}
.material-input .form-control[disabled] ~ label {color: #adb5bd;}
.material-input .form-control[readonly] ~ label {background: #e9ecef;}
.material-input .form-control:focus ~ label,
.material-input .form-control:not(:placeholder-shown) ~ label {top: 5px;left: 8px;font-size: 12px;color: #000000;width: max-content;background: none;}
.material-input .form-control[disabled]:focus ~ label,
.material-input .form-control[disabled]:not(:placeholder-shown) ~ label {top: -12px;left: 8px;font-size: 12px;color: #adb5bd;width: max-content;}
.material-input .form-control[readonly]:focus ~ label,
.material-input .form-control[readonly]:not(:placeholder-shown) ~ label {background: #e9ecef;}
/*--Materiel Input Box Css Stopped--*/

/*--Materiel Select Box Css Started--*/
.material-select {position: relative;margin-bottom: 20px;}
.material-select select {padding: 20px 12px 5px 12px;border: 1px solid #ced4da;border-radius: 4px;background: transparent;width: 100%;transition: border-color 0.3s ease, box-shadow 0.3s ease;appearance: none;}
.material-select select[disabled],
.material-select select[readonly] {background-color: #e9ecef;border: 1px solid #ced4da;color: #6c757d;}
.material-select select[disabled] {cursor: not-allowed;}
.material-select select[readonly] {cursor: default;}
.material-select select:focus {border: 1px solid #212529;box-shadow: 0 0 0 0.2rem #0000003b;outline: none;}
.material-select label {position: absolute;top: 18px;left: 12px;pointer-events: none;font-size: 16px;transition: all 0.2s ease;background: white;padding: 2px 4px;color: #6c757d;width: 80%;}
.material-select select:focus ~ label,
.material-select select:not([value=""]) ~ label {top: 5px;left: 8px;font-size: 12px;color: #000000;width: max-content;}
.material-select select[readonly]:focus ~ label,
.material-select select[readonly]:not([value=""]) ~ label,
.material-select select[disabled]:focus ~ label,
.material-select select[disabled]:not([value=""]) ~ label{top: 5px;left: 8px;font-size: 12px;color: #000000;width: max-content;background: #e9ecef;}
.material-select::after {content: '\25BC';position: absolute;top: 22px;right: 16px;pointer-events: none;font-size: 16px;color: #6c757d;}
.material-select select:focus ~ .material-select::after {color: #212529;}

/*-- Material Checkbox design started--*/
.checkbox-container {display: flex;align-items: start;cursor: pointer;user-select: none;font-family: Arial, sans-serif;}
.checkbox-container input {position: absolute;opacity: 0;cursor: pointer;}
.checkmark {height: 18px;width: 18px;background-color: #eee;border: 2px solid #bdbdbd;border-radius: 2px;position: relative;transition: all 0.2s ease-in-out;padding-right: 14px;margin-top: 4px;}
.checkbox-container input:checked ~ .checkmark {background-color: #212529;border-color: #212529;}
.checkmark:after {content: "";position: absolute;display: none;left: 5px;top: 1px;width: 5px;height: 10px;border: solid white;border-width: 0 2px 2px 0;transform: rotate(45deg);}
.checkbox-container input:checked ~ .checkmark:after {display: block;}
.checkbox-label {margin-left: 8px;color: #333;}
/* Responsive Adjustments */

/*-- Material Checkbox design stopped--*/

</style>
<script>
import { mapActions, mapGetters } from 'vuex';
import ErrorAlert from "./ErrorAlert";
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import BestDropdown from "./layouts/BestDropdown.vue";

export default {
    name: "TabUserInformation",
    props: {
        userDetails: {
            type:Object,
            required: false
        },
        userDetailsAddress: {
            type:Object,
            required: false
        },
        activeTab:String,
        showShipping:Boolean,
        services:String,
        paymentStatus:String
      
    },
    components:{
        'error-alert' : ErrorAlert,
        'vue-google-autocomplete': VueGoogleAutocomplete,
        'best-dropdown' : BestDropdown
    },
    data() {
        return {
            addressError: '',
            servicepointloading: false,
            servicePointAddress: [],
            shippingAddressType: '',
            showServices: false,
            status: false,
            errors: [],
            form: {
                salutation: this.userDetails && this.userDetails.salutation ? this.userDetails.salutation : 'mr',
                firstName: this.userDetails && this.userDetails.first_name ? this.userDetails.first_name : null,
                lastName: this.userDetails && this.userDetails.last_name ? this.userDetails.last_name : null ,
                email: this.userDetails && this.userDetails.email ? this.userDetails.email : null,
                jobTitle: this.userDetails && this.userDetails.job_title ? this.userDetails.job_title : null,
                companyBranch: this.userDetails && this.userDetails.company_branch ? this.userDetails.company_branch : null,
                contactNumber: this.userDetails && this.userDetails.contact_number ? this.userDetails.contact_number : null,
                countryCode: this.userDetails && this.userDetails.country_code ? this.userDetails.country_code : '358',
                licencePlate: null,
                billingAddress: {
                    address1: null,
                    address2: null,
                    city: null,
                    zipcode: null,
                    country: "73"
                },
                shippingAddress: {
                    address1: null,
                    address2: null,
                    city: null,
                    zipcode: null,
                    country: "73"
                },
                order_note:'',
                conditions: ''
            },
            bindProps: {
                defaultCountry: "FI"
            },
            options: [
                { value: 'mr', text: 'Mr' },
                { value: 'miss', text: 'Miss' },
                { value: 'mrs', text: 'Mrs' }
            ],
            address: '',
            tempAddress: null,
            shippingMethodTypes: [
              { value: 'billing', text: 'Same as billing address' },
              { value: 'different', text: 'Ship to different location' },
              { value: 'servicepoint', text: 'Ship to service point' }
            ],
            failedOrder: {},
            processError: { display: false, message: '' },
            isFormValid: false,
        }
    },
    watch: {
        cartProducts:{
            immediate: true,
            handler(newValue) {
                if(newValue.length==0){
                    this.$router.push({
                        path: '/cart',
                        params: {}
                    })
                }
            }
        },
        'form.billingAddress': {
            immediate: true,
            deep:true,
            handler(newValue) {
                this.form.billingAddress = newValue
            }
        },
        'form.shippingAddress': {
            immediate: true,
            deep:true,
            handler(newValue) {
                this.form.shippingAddress = newValue
            }
        },
        status: {
            handler(newValue) {
                if ( newValue == 1 ) {
                    this.sameAddress(newValue);
                }
            }
        },
        'form.billingAddress.address1': {
            handler() {
                if (this.shippingAddressType == 'billing') {
                    this.form.shippingAddress.address1 = this.form.billingAddress.address1;
                }
            }
        },
        'form.billingAddress.address2': {
            handler() {
                if (this.shippingAddressType == 'billing') {
                    this.form.shippingAddress.address2 = this.form.billingAddress.address2;
                }
            }
        },
        'form.billingAddress.zipcode': {
            handler() {
                if ( this.shippingAddressType == 'billing' ) {
                    this.form.shippingAddress.zipcode = this.form.billingAddress.zipcode;
                }
            }
        },
        'form.billingAddress.city': {
            handler() {
                if (this.shippingAddressType == 'billing') {
                    this.form.shippingAddress.city = this.form.billingAddress.city;
                }
            }
        },
        'form.billingAddress.country': {
            handler() {
                if (this.shippingAddressType == 'billing') {
                    this.form.shippingAddress.country = this.form.billingAddress.country;
                }
            }
        },
        shippingAddressType: {
            handler() {
                this.setShippingAddressType()    
            }
        },
        dealerServiceList: {
            handler(newVal) {
                if (this.shippingDetailsCached && this.shippingDetailsCached.servicePointAddress) {
                    let dealerFound = null
                    newVal.forEach(e => {
                        if (e.id == this.shippingDetailsCached.servicePointAddress.id) {
                            dealerFound = this.shippingDetailsCached.servicePointAddress
                        }
                    });

                    if (dealerFound) {
                        this.servicePointAddress = dealerFound
                    } else {
                        this.servicePointAddress = []    
                    }
                }
                // this.servicePointAddress = newVal[0]
            }
        },
        servicePointAddress: {
            handler(newVal) {
                this.setServicePointShippingAddress(newVal)
                this.csSetRightSidebarDealerData(newVal)
            }
        },        
    },
    async created() {

        if (this.$route.params.orderNumber) {
          await this.getDetailsByOrderNumber(this.$route.params.orderNumber)
          this.$router.push({ path: `/cart/user-info/`, replace: true });
        }

        await this.getAllCartProducts()
        if(localStorage.getItem("shippingAddressType")){
            this.shippingAddressType = localStorage.getItem("shippingAddressType");
        } else {
            this.shippingAddressType = 'billing';
        }

        if(this.shippingAddressType == 'servicepoint') {
            if (this.strAddressWS != '' && this.$refs.autocomplete) {
                this.showServices = true
            }

            this.setStrAddressWS(localStorage.getItem("cart_shipping_temp_address"))

            if(localStorage.getItem("setDealerServiceApiParamsCachedWS")){
                let params = "";
                params = localStorage.getItem('setDealerServiceApiParamsCachedWS');
                this.setDealerServiceApiParamsCachedWS(params);
            }

            if(localStorage.getItem("cart_shipping_temp_address")){
                this.address = localStorage.getItem("cart_shipping_address");
                this.getDealerServices();
            }
        }

        $('.form-control').removeAttr('readonly');
        this.fetchCountries()

        if (localStorage.getItem('billingDetails') && localStorage.getItem('shippingDetails')) {

            if(this.shippingAddressType == 'servicepoint') {
                this.servicePointAddress = JSON.parse(localStorage.getItem('setShippingDetailsToCached')).servicePointAddress;
            }
            
            this.setAddressesToCache(JSON.parse(localStorage.getItem('billingDetails')), JSON.parse(localStorage.getItem('shippingDetails')))
        }

        

        if (this.paymentStatus == "failed") {
            this.shippingAddressType = localStorage.getItem('shippingAddressType');
            
            // if(this.shippingAddressType == 'servicepoint') {
            
            //     this.address = JSON.parse(localStorage.getItem('address'));

            //     this.getDealerServices(this.currentLang)

            //     this.showServices = true;
            // }

            if (this.shippingDetailsCached) {

                this.form.firstName = this.shippingDetailsCached.billingDetails.first_name;
                this.form.lastName = this.shippingDetailsCached.billingDetails.last_name;
                this.form.contactNumber = this.shippingDetailsCached.billingDetails.contact_number;
                this.form.email = this.shippingDetailsCached.billingDetails.email;

                this.form.billingAddress.address1 = this.shippingDetailsCached.billingDetails.address_line_1;
                this.form.billingAddress.address2 = this.shippingDetailsCached.billingDetails.address_line_2;
                this.form.billingAddress.city = this.shippingDetailsCached.billingDetails.city;
                this.form.billingAddress.zipcode = this.shippingDetailsCached.billingDetails.zipcode;
                this.form.billingAddress.country = this.shippingDetailsCached.billingDetails.country_id;

                let sType = this.shippingDetailsCached.shippingAddressType
                if (sType == 'billing') {
                    this.status = 1
                } else if (sType == 'different') {
                    this.status = 0
                } else if(sType == 'servicepoint') {
                    this.status = 0
                }

                this.shippingAddressType = this.shippingDetailsCached.shippingAddressType;

                this.form.shippingAddress.address1 = this.shippingDetailsCached.shippingDetails.address_line_1;
                this.form.shippingAddress.address2 = this.shippingDetailsCached.shippingDetails.address_line_2;
                this.form.shippingAddress.city = this.shippingDetailsCached.shippingDetails.city;
                this.form.shippingAddress.zipcode = this.shippingDetailsCached.shippingDetails.zipcode;
                this.form.shippingAddress.country = this.shippingDetailsCached.shippingDetails.country_id;



                } else if (this.userDetails) {
                await this.getProfileDetail(this.userDetails.id);

                this.form.billingAddress.address1 = this.profileDetails.userAddress.billingAddress.address_line_1;
                this.form.billingAddress.address2 = this.profileDetails.userAddress.billingAddress.address_line_2;
                this.form.billingAddress.city = this.profileDetails.userAddress.billingAddress.city;
                this.form.billingAddress.zipcode = this.profileDetails.userAddress.billingAddress.zipcode;
                this.form.billingAddress.country = this.profileDetails.userAddress.billingAddress.country_id;

                this.status = this.profileDetails.userAddress.billingAddress.same_as_shipping;

                this.form.shippingAddress.address1 = this.profileDetails.userAddress.shippingAddress.address_line_1;
                this.form.shippingAddress.address2 = this.profileDetails.userAddress.shippingAddress.address_line_2;
                this.form.shippingAddress.city = this.profileDetails.userAddress.shippingAddress.city;
                this.form.shippingAddress.zipcode = this.profileDetails.userAddress.shippingAddress.zipcode;
                this.form.shippingAddress.country = this.profileDetails.userAddress.shippingAddress.country_id;
            }

            this.getDealerServices(this.currentLang)
            
        } else {
            if (this.shippingDetailsCached) {
                
                if(this.shippingAddressType == 'servicepoint') {

                    if (localStorage.getItem('setShippingDetailsToCached')) {
                        await this.setShippingDetailsToCached(JSON.parse(localStorage.getItem('setShippingDetailsToCached')));
                    }
                }

                this.form.firstName = this.shippingDetailsCached.billingDetails.first_name;
                this.form.lastName = this.shippingDetailsCached.billingDetails.last_name;
                this.form.contactNumber = this.shippingDetailsCached.billingDetails.contact_number;
                this.form.email = this.shippingDetailsCached.billingDetails.email;

                this.form.billingAddress.address1 = this.shippingDetailsCached.billingDetails.address_line_1;
                this.form.billingAddress.address2 = this.shippingDetailsCached.billingDetails.address_line_2;
                this.form.billingAddress.city = this.shippingDetailsCached.billingDetails.city;
                this.form.billingAddress.zipcode = this.shippingDetailsCached.billingDetails.zipcode;
                this.form.billingAddress.country = this.shippingDetailsCached.billingDetails.country_id;

                let sType = this.shippingDetailsCached.shippingAddressType
                if (sType == 'billing') {
                    this.status = 1
                } else if (sType == 'different') {
                    this.status = 0
                } else if(sType == 'servicepoint') {
                    this.status = 0
                }

                this.shippingAddressType = this.shippingDetailsCached.shippingAddressType;

                this.form.shippingAddress.address1 = this.shippingDetailsCached.shippingDetails.address_line_1;
                this.form.shippingAddress.address2 = this.shippingDetailsCached.shippingDetails.address_line_2;
                this.form.shippingAddress.city = this.shippingDetailsCached.shippingDetails.city;
                this.form.shippingAddress.zipcode = this.shippingDetailsCached.shippingDetails.zipcode;
                this.form.shippingAddress.country = this.shippingDetailsCached.shippingDetails.country_id;
            } else if (this.userDetails) {
                await this.getProfileDetail(this.userDetails.id);

                this.form.billingAddress.address1 = this.profileDetails.userAddress.billingAddress.address_line_1;
                this.form.billingAddress.address2 = this.profileDetails.userAddress.billingAddress.address_line_2;
                this.form.billingAddress.city = this.profileDetails.userAddress.billingAddress.city;
                this.form.billingAddress.zipcode = this.profileDetails.userAddress.billingAddress.zipcode;
                this.form.billingAddress.country = this.profileDetails.userAddress.billingAddress.country_id;

                this.status = this.profileDetails.userAddress.billingAddress.same_as_shipping;

                this.form.shippingAddress.address1 = this.profileDetails.userAddress.shippingAddress.address_line_1;
                this.form.shippingAddress.address2 = this.profileDetails.userAddress.shippingAddress.address_line_2;
                this.form.shippingAddress.city = this.profileDetails.userAddress.shippingAddress.city;
                this.form.shippingAddress.zipcode = this.profileDetails.userAddress.shippingAddress.zipcode;
                this.form.shippingAddress.country = this.profileDetails.userAddress.shippingAddress.country_id;
            }
            this.getDealerServices(this.currentLang)
        }
        
    },
    computed: {
        ...mapGetters('countryListing', [ 'countriesList' ]),
        ...mapGetters('cart', [ 'cartId', 'cartProducts', 'rimSizes', 'cartDetails', 'cartShippingAddressType']),
        ...mapGetters('order', [ 'orderDetails', 'proceedLoading', 'paymentDetails', 'orderResponse', 'isShow', 'shippingDetailsCached']),
        ...mapGetters('auth', ['loggedIn']),
        ...mapGetters('editprofile', ['profileDetails']),
        ...mapGetters('dealerservices', ['loading', 'dealerServiceList', 'searchZipCode', 'strAddressWS', 'dealerServiceApiParamsCachedWS']),
    },
    mounted() {
        this.setUserAddress()
        this.resetError()
        this.setShippingAddressType()
        if (this.strAddressWS && this.$refs.autocomplete) {
            this.$refs.autocomplete.update(this.strAddressWS)
        }
        if ("order_note" in localStorage) {
          this.form.order_note = localStorage.getItem("order_note");
        }
        if ("licencePlate" in localStorage) {
          this.form.licencePlate = localStorage.getItem("licencePlate");
        }

    },
    methods: {
        ...mapActions('countryListing', ['fetchCountries']),
        ...mapActions('editprofile', ['getProfileDetail']),
        ...mapActions('dealerservices', ['fetchDealerServices', 'setSearchedZipcode', 'setDealerServicesList', 'setStrAddressWS', 'setDealerServiceApiParamsCachedWS']),
        ...mapActions('order', ['confirmOrderWithPaytrail', 'setUserOrder', 'updateShippingDetails', 'showError', 'resetError', 'setShippingDetailsToCached', 'processPaymentWithPaytrail', 'getDetailsByOrderNumber', 'processPaymentWithKlarna']),
        ...mapActions('cart', ['updateCartShippingAddressType', 'getAllCartProducts']),
        ...mapActions('cart_right_sidebar', ['csWOSetName', 'csWOSetEmail', 'csWOSetPhone', 'csWOSetDate', 'csWOSetAddress', 'csWOSetCity', 'csWOSetTime', 'csWOSetDealerId', 'csWOSetTimeSlots', 'csWOSaveDealerToLocalStorage', 'csWORemoveDealerFromLocalStorage', 'csSetIsWithService']),
        /*async payWithPaytrail() {
        let processData = new FormData();
        processData.append('order_id', this.orderDetails.id);
        this.processPaymentWithPaytrail(processData)
            .then( () => {
              if(this.paymentDetails.url) {

                var gtag_products = [];

                this.orderDetails.line_items.forEach(function(product) {
                  if (product.type == "product") {
                    gtag_products.push({
                      'item_id': product.id,
                      'item_name': product.product.name,
                      'affiliation' : product.type,
                      'price': product.unit_price,
                      'type_id': product.type_id,
                      'quantity': product.quantity,
                      'item_category': product.product.car_type
                    })
                  }
                })

                // gtag begin checkout
                this.googleTagBeginCheckout(this.orderDetails.total, gtag_products);
                window.location.href = this.paymentDetails.url;
              }
            }).catch(error => {
          this.processError.display = true
          this.processError.message = error.response.data.errors[0]
          window.scrollTo(0,0)
        });
      },
        async payWithKlarna() {
        let processData = new FormData();
        processData.append('order_id', this.orderDetails.id);
        await this.processPaymentWithKlarna(processData).then(() => {
          if(this.paymentDetails.url) {

            var gtag_products = [];

            this.orderDetails.line_items.forEach(function(product) {
              if (product.type == "product") {
                gtag_products.push({
                  'item_id': product.id,
                  'item_name': product.product.name,
                  'affiliation' : product.type,
                  'price': product.unit_price,
                  'type_id': product.type_id,
                  'quantity': product.quantity,
                  'item_category': product.product.car_type
                })
              }
            })

            this.googleTagBeginCheckout(this.orderDetails.total, gtag_products);

            window.location.href = this.paymentDetails.url;
          }
        }).catch(error => {
          this.processError.display = true
          this.processError.message = error.response.data.errors[0]
          window.scrollTo(0,0)
        });
      },*/
        goToServicePointOrCart() {
            if (this.showShipping) {
              this.$router.push({path: "/cart", params: {} });
              this.getAllCartProducts()
            } else {
              this.$router.push({ path: "/cart/dealer-services", name: "dealer-services", params: {} });
              window.scrollTo(0, 0);
            }
        },
        customLabel({ company_name, city }) {
            return `${company_name} - ${city}`
        },
        handleSubmit() {

            this.resetError();
            var setflag = true;
            var contactNumberRegex = /^(?=(?:[^\d]*\d){7,12}[^\d]*$)[\d\+\-\ ,()]+$/;
            this.errors = []
            if (!this.form.firstName) {
                setflag = false;
                this.errors.push(this.$t('Firstname is required.'));
            
            }
            if (!this.form.lastName) {
                setflag = false;
                this.errors.push(this.$t('Lastname is required.'));
            }
            if (!this.form.email) {
                setflag = false;
                this.errors.push(this.$t('Email is required.'));
            }
            if (!this.form.contactNumber) {
                setflag = false;
                this.errors.push(this.$t('Contact Number is required.'));
            } else if(!contactNumberRegex.test(this.form.contactNumber)){
                setflag = false;
                this.errors.push(this.$t('Contact Number must contains 7 to 12 digits. It allows +,-,(,) and space'));
            }
            if(!this.form.billingAddress.address1 || this.form.billingAddress.address1.trim() == '') {
                setflag = false;
                this.errors.push(this.$t('Street number and building number of billing address is required.'));
            }
            if(!this.form.billingAddress.city || this.form.billingAddress.city.trim()=='') {
                setflag = false;
                this.errors.push(this.$t('City of billing address is required.'));
            }
            if(!this.form.billingAddress.country) {
                setflag = false;
                this.errors.push(this.$t('Country of billing address is required.'));
            }
            if(!this.form.billingAddress.zipcode || this.form.billingAddress.zipcode.trim() == '') {
                setflag = false;
                this.errors.push(this.$t('Zipcode of billing address is required.'))
            } else if (this.form.billingAddress.zipcode.length != 5) { 
                setflag = false;
                this.errors.push(this.$t('Zipcode of billing address allow only 5 digit.'));
            }
            if ( this.shippingAddressType == 'servicepoint' && Object.keys(this.servicePointAddress).length == 0 ) {
                setflag = false
                this.errors.push(this.$t('Please select an service point address as an shipping address'))
            }

            if (this.showShipping) {
                if(!this.form.shippingAddress.address1) {
                    setflag = false;
                    this.errors.push(this.$t('Street number and building number of shipping address is required.'))
                }
                if(!this.form.shippingAddress.city) {
                    setflag = false;
                    this.errors.push(this.$t('City of shipping address is required.'))
                }
                if(!this.form.shippingAddress.country) {
                    setflag = false;
                    this.errors.push(this.$t('Country of shipping address is required.'))
                }
                if(!this.form.shippingAddress.zipcode || this.form.shippingAddress.zipcode.trim() == '') {
                    this.errors.push(this.$t('Zipcode of shipping address is required.'))
                } else if (this.form.shippingAddress.zipcode.length != 5) { 
                    setflag = false;
                    this.errors.push(this.$t('Zipcode of shipping address allow only 5 digit.'));
                }
            }

            if(setflag) {
                this.resetError();
                this.setUserInformation()
            } else {
                this.showError({'msg': '', 'errors': JSON.parse(JSON.stringify( this.errors ))});
                window.scrollTo(0,0)
            }
        },
        setUserInformation() {
            if(this.cartId) {
                let formData = new FormData();
                formData.append('cart_id', this.cartId)
                this.setUserOrder(this.form)
                this.confirmOrderWithPaytrail(formData)
                .then(() => {
                    let billingDetails = {
                        "address_type": "billing",
                        "first_name":this.form.firstName,
                        "last_name":this.form.lastName,
                        "email":this.form.email,
                        "contact_number":this.form.contactNumber,
                        "address_line_1":this.form.billingAddress.address1,
                        "address_line_2":this.form.billingAddress.address2,
                        "zipcode":this.form.billingAddress.zipcode,
                        "city":this.form.billingAddress.city,
                        "country_id":this.form.billingAddress.country
                    }
                    
                    let updateDetails = new FormData();
                    updateDetails.append('order_id', this.orderDetails.id);
                    updateDetails.append('billing_details', JSON.stringify(billingDetails));
                    updateDetails.append('is_gone_at_klaviyo', '0');

                    let shippingDetails = {}
                    if(this.showShipping) {
                        if ( this.shippingAddressType == 'servicepoint' ) {
                            shippingDetails = {
                                'address_type':'shipping',
                                'order_id': this.orderDetails.id,
                                'first_name': this.servicePointAddress.dealer_first_name,
                                'last_name': this.servicePointAddress.dealer_last_name,
                                'email': this.servicePointAddress.dealer_email,
                                'contact_number': this.servicePointAddress.contact_number,
                                'address_line_1': this.form.shippingAddress.address1,
                                'address_line_2': this.form.shippingAddress.address2,
                                'zipcode': this.form.shippingAddress.zipcode,
                                'city': this.form.shippingAddress.city,
                                'country_id': this.form.shippingAddress.country,
                                'ship_to': this.shippingAddressType,
                                'dealer_id': this.servicePointAddress.dealer_id
                            }
                        } else {
                            shippingDetails = {
                                'address_type':'shipping',
                                'order_id': this.orderDetails.id,
                                'first_name': this.form.firstName,
                                'last_name': this.form.lastName,
                                'email': this.form.email,
                                'contact_number': this.form.contactNumber,
                                'address_line_1': this.form.shippingAddress.address1,
                                'address_line_2': this.form.shippingAddress.address2,
                                'zipcode': this.form.shippingAddress.zipcode,
                                'city': this.form.shippingAddress.city,
                                'country_id': this.form.shippingAddress.country,
                                'ship_to': this.shippingAddressType
                            }
                        }

                        updateDetails.append('shipping_details', JSON.stringify(shippingDetails));
                    }
                    updateDetails.append('order_note', this.form.order_note);
                    updateDetails.append('licence_plate', this.form.licencePlate);

                    localStorage.setItem('billingDetails', JSON.stringify(billingDetails))
                    localStorage.setItem('shippingDetails', JSON.stringify(shippingDetails))

                    localStorage.setItem('order_note', this.form.order_note);
                    localStorage.setItem('licencePlate', this.form.licencePlate);

                    this.klaviyoIdentifyUser()

                    this.setAddressesToCache(billingDetails, shippingDetails)

                    this.updateShippingDetails(updateDetails)
                    .then(() => {
                        this.$router.push({ 
                            path: '/cart/order-summary/'+ this.orderDetails.order_number,
                            params: {},
                        });
                    })
                    .catch(error => {
                        this.setflag = false
                        for (let [key,value] of Object.entries(error.response.data)) {
                            this.errors.push(this.$t(value[0]));
                        }
                        this.showError({'msg': '', 'errors': JSON.parse(JSON.stringify( this.errors ))});
                        window.scrollTo(0,0)
                    })             
                });
                
            }
        },
        setUserAddress() {
            let userShippingAddress = (this.userDetailsAddress && this.userDetailsAddress.shippingAddress && this.userDetailsAddress.shippingAddress.length > 0)
            ? this.userDetailsAddress.shippingAddress
            : null;
            let userBillingAddress = (this.userDetailsAddress && this.userDetailsAddress.billingAddress &&this.userDetailsAddress.billingAddress.length > 0)
            ? this.userDetailsAddress.billingAddress
            : null;
            if(userBillingAddress) {
                this.form.billingAddress = {
                    address1: (userBillingAddress.address_line_1)?(userBillingAddress.address_line_1):null,
                    address2: (userBillingAddress.address_line_2)?(userBillingAddress.address_line_2):null,
                    city: (userBillingAddress.city)? userBillingAddress.city: null ,
                    zipcode: (userBillingAddress.zipcode) ? userBillingAddress.zipcode :null,
                    country: (userBillingAddress.country_id) ? userBillingAddress.country_id:null
                }
            }
            if(userShippingAddress) {
                this.form.shippingAddress = {
                    address1: (userShippingAddress.address_line_1)?userShippingAddress.address_line_1:null,
                    address2: (userShippingAddress.address_line_2)?userShippingAddress.address_line_2:null,
                    city: userShippingAddress.city?userShippingAddress.city:null,
                    zipcode: userShippingAddress.zipcode?userShippingAddress.zipcode:null,
                    country: userShippingAddress.country_id?userShippingAddress.country_id:null
                }
            }
        },
        onSelect({name, iso2, dialCode}) {
            this.form.countryCode = dialCode;
        },
        sameAddress(status){
            if(status == 1 && this.shippingAddressType != 'servicepoint') {
                this.form.shippingAddress.address1 = this.form.billingAddress.address1;
                this.form.shippingAddress.address2 = this.form.billingAddress.address2;
                this.form.shippingAddress.zipcode = this.form.billingAddress.zipcode;
                this.form.shippingAddress.city = this.form.billingAddress.city;
                this.form.shippingAddress.country = this.form.billingAddress.country;
            }
        },
        setShippingAddressType() {
            if ( this.shippingAddressType == 'billing' ) {
                this.status = true
                this.sameAddress(1)
                if ("service" in localStorage && localStorage.getItem("service") == '') {
                  //this.csRemoveDealerFromLocalStorage();
                }
            } else if ( this.shippingAddressType == 'different' ) {
                this.status = false
                this.sameAddress(0)
                if ("service" in localStorage && localStorage.getItem("service") == '') {
                  //this.csRemoveDealerFromLocalStorage();
                }
            } else if( this.shippingAddressType == 'servicepoint' ) {
                this.status = true
                this.form.shippingAddress.address1 = ''
                this.form.shippingAddress.address2 = ''
                this.form.shippingAddress.city = ''
                this.form.shippingAddress.zipcode = ''
                this.form.shippingAddress.country = ''
            }

            localStorage.setItem('shippingAddressType', this.shippingAddressType)
            this.updateCartShippingAddressType(this.shippingAddressType);

            this.setDealerServicesList()
            // this.address = ''

        },
        setServicePointShippingAddress(address) {
            if ( Object.keys(address).length > 0 ) {
                this.form.shippingAddress.address1 = address.address_line_1;
                this.form.shippingAddress.address2 = address.address_line_2;
                this.form.shippingAddress.zipcode = address.zipcode;
                this.form.shippingAddress.city = address.city;
                this.form.shippingAddress.country = 73; // fixed country id for finland
            }
        },
        getAddressData(addressData, placeResultData, id) {

            this.tempAddress = placeResultData
              
            let tmpAddr = placeResultData.address_components.map(e => {
                if (isNaN(e.long_name)) {
                    return e.long_name
                }
            })
            tmpAddr = tmpAddr.filter(e => e)
            tmpAddr = tmpAddr.join(", ")

            localStorage.setItem('tempAddress', tmpAddr)

            this.address = JSON.stringify(addressData);
            localStorage.setItem('cart_shipping_temp_address', tmpAddr);
            localStorage.setItem('cart_shipping_address', this.address);
        },
        getDealerServices(lang = "") {
            if(this.cartProducts.length > 0) {
                // if ( this.address == '' ) {
                //     console.log('border border-danger')
                //     this.addressError = 'border border-danger'
                //     this.setDealerServicesList()
                //     this.address = ''
                //     return false
                // } else {
                //     this.addressError = ''
                // }
                this.servicepointloading = true

                let params= '';

                if (this.dealerServiceApiParamsCachedWS.length > 0 && !this.address) {
                    params = this.dealerServiceApiParamsCachedWS
                } else {
                    let addressCoordinates = (this.address) ? JSON.parse(this.address) : null
                    if(addressCoordinates && addressCoordinates.latitude) {
                        params = 'latitude=' + addressCoordinates.latitude
                    }
                    if(addressCoordinates && addressCoordinates.longitude) {
                        params = params + '&longitude=' + parseFloat(addressCoordinates.longitude).toFixed(8)
                    }
                    /* if(this.services && this.services.length) {
                        params = params + '&service_ids='+this.services
                    } */
                    if(this.rimSizes && this.rimSizes.length) {
                        var rims = [];
                        this.rimSizes.forEach(function(part, index) {
                            let rim = part.split(':')
                            if(rim[1]) {
                                rims[index] = rim[1];
                            }
                        }, rims);
                        params = params + '&rim_sizes='+ '[' + _.join(_.uniq(rims), [',']) + ']'
                    }
                    let locale_code = (this.currentLang == '') ? 'fi_FI' : this.currentLang
                    let locale_id = (locale_code == 'en_GB') ? 1 : 2
                    params = params + '&locale_id='+ locale_id
                    params = params + '&with=["timeSlots","workingDays"]'
                }

                this.fetchDealerServices(params).finally(() => {
                    this.servicepointloading = false
                })

                localStorage.setItem('setDealerServiceApiParamsCachedWS', params);

                this.setDealerServiceApiParamsCachedWS(params)
                this.setSearchedZipcode(this.address);
                this.showServices = true;

                if (this.tempAddress) {
                    this.tempAddress = this.tempAddress.address_components.map(e => {
                        if (isNaN(e.long_name)) {
                            return e.long_name
                        }
                    })
                    this.tempAddress = this.tempAddress.filter(e => e)
                    this.tempAddress = this.tempAddress.join(", ")
                    this.setStrAddressWS(this.tempAddress)
                }
            }
        },
        distanceToLocation(distanceInKm) {
            let distance = 0
            distance = distanceInKm.toFixed(2).replace(".", ",")
            return distance
        },
        setAddressesToCache(billingDetails, shippingDetails) {
            let detailsObj = {
                billingDetails: billingDetails, 
                shippingDetails: shippingDetails,
                shippingAddressType: this.shippingAddressType,
                servicePointAddress: this.servicePointAddress
            }

           // this.form.conditions = true;
            localStorage.setItem('setShippingDetailsToCached', JSON.stringify(detailsObj));

            this.setShippingDetailsToCached(detailsObj)
        },
        csSetRightSidebarDealerData(dealer) {
          if (typeof dealer == 'object' && dealer.length != 0) {
            this.csWOSetName('( '+ dealer.company_name + ' ) '+dealer.dealer_first_name + dealer.dealer_last_name);
            this.csWOSetEmail(dealer.dealer_email);
            this.csWOSetPhone(dealer.contact_number);
            this.csWOSetAddress(dealer.address_line_1 + ' ' + (dealer.address_line_2 || ''));
            this.csWOSetCity(dealer.city);
            this.csWOSetDate('');
            this.csWOSetTime('');
            this.csWOSetDealerId(dealer.id);
            this.csWOSetTimeSlots(dealer.time_slots);
            this.csWOSaveDealerToLocalStorage();
            this.csSetIsWithService(false);
          }
        },
        HandleSelectedShipping(ShippingType) {
          this.shippingAddressType = ShippingType.value
        },
        validateFormData() {
            this.isFormValid = (
                   this.form.firstName 
                && this.form.lastName 
                && this.form.contactNumber 
                && this.form.email 
                && this.form.billingAddress.address1
                && this.form.billingAddress.zipcode 
                && this.form.billingAddress.city 
                && this.form.billingAddress.country
                && this.form.conditions
            ) ? true : false;

            if(this.form.email){
                this.klaviyoIdentifyUser(this.form.email);
            }
        }
        
    }
}
</script>